import React, {useState} from 'react';
import {BookOpenText} from "lucide-react";
import {Button, Modal} from "antd";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {URLS} from "@/lib/urls";
import {useApiStudentStartExam} from "@/api/lesson";
import {useNavigate, useParams} from "react-router-dom";
import RenderIf from "@/components/render-if";
import {sprintf} from "@/lib/utils/sprintf";

function ExamStartSection({data}) {
    const navigate = useNavigate();
    const param = useParams();


    const [showWithdrawalModal, setShowWithdrawalModal] = useState(false);
    const {mutate: startExam, isPending: isPending} = useApiStudentStartExam()

    function handleStartExam() {

        startExam({id: param.id}, {
            onSuccess: (e) => {
                ApiHandleSuccessMessage(e)

                setShowWithdrawalModal(false)
                navigate(sprintf(URLS.student.lessons.exam, {id: e?.data?.data?.id}))
            },
            onError: (e) => {
                ApiHandleErrorMessage(e)
            }
        });
    }

    return (
        <>
            <Modal
                title="شروع آزمون"
                footer={[]}
                open={showWithdrawalModal}
                onCancel={() => setShowWithdrawalModal(false)}
            >

                <div className="mb-6">
                    {/* پیام اصلی آزمون */}
                    <div className="flex items-start gap-3 p-4 bg-blue-50 border border-blue-200 rounded-lg mb-4">
                        <BookOpenText className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0"/>
                        <div>
                            <h4 className="font-medium text-blue-900 mb-1">توجه!</h4>
                            <p className="text-blue-700 text-sm whitespace-pre-line">
                                {data?.data?.data?.lesson?.topic?.exammsg}
                            </p>
                        </div>
                    </div>

                    {/* جزئیات آزمون */}
                    {data?.data?.data?.lesson?.topic?.examdetail && (
                        <div className="p-4  border border-gray-200 rounded-lg shadow-sm">
                            <h5 className="font-semibold  mb-3 flex items-center gap-2">
                                <BookOpenText className="w-4 h-4 text-blue-500"/>
                                جزئیات آزمون
                            </h5>
                            <ul className=" text-sm space-y-2">
                                <li>
                                    <span className="font-medium ">تعداد سؤالات:</span>{" "}
                                    {data?.data?.data?.lesson?.topic?.examdetail?.countrand}
                                </li>
                                <li>
                                    <span className="font-medium ">مدت زمان آزمون:</span>{" "}
                                    {data?.data?.data?.lesson?.topic?.examdetail?.time} دقیقه
                                    <br/>
                                    <span><small>بعد از شروع آزمون شما باید در مدت زمان مشخص شده به تمامی سوالات پاسخ دهید</small></span>
                                </li>
                                <RenderIf condition={data?.data?.data?.lesson?.topic?.examdetail?.calculatescore}>
                                    <li>
                                        <span className="font-medium ">نمره قبولی از:</span>{" "}
                                        {data?.data?.data?.lesson?.topic?.examdetail?.calculatescore}
                                    </li>
                                </RenderIf>
                                <RenderIf condition={data?.data?.data?.lesson?.topic?.examdetail?.counttake}>
                                    <li>
                                    <span
                                        className="font-medium ">تعداد دفعات مجاز شرکت در آزمون:</span>{" "}
                                        {data?.data?.data?.lesson?.topic?.examdetail?.counttake}
                                    </li>
                                </RenderIf>
                            </ul>
                        </div>
                    )}
                </div>


                <div className="flex gap-3">
                    <Button

                        onClick={() => setShowWithdrawalModal(false)}
                        className="flex-1 px-4 py-2 border border-gray-300  rounded-lg hover:bg-gray-50 transition-colors"
                    >
                        انصراف
                    </Button>
                    <Button
                        loading={isPending}
                        onClick={() => handleStartExam()}
                        className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                        آماده ام. شروع آزمون
                    </Button>
                </div>
            </Modal>

            <div className=" rounded-2xl shadow-lg p-6 border border-gray-100 dark:border-gray-600">
                <div className="flex items-center gap-3 mb-4">
                    <div className="p-2 bg-blue-100 rounded-lg">
                        <BookOpenText className="w-6 h-6 text-blue-600"/>
                    </div>
                    <h3 className="text-lg font-semibold ">آزمون درس</h3>
                </div>

                <p className=" text-sm mb-4">
                    برای شرکت در آزمون این درس کلیک کنید
                </p>

                <button
                    onClick={() => setShowWithdrawalModal(true)}
                    className="w-full px-4 py-2 bg-blue-50 dark:bg-blue-950/30 text-blue-700 dark:text-blue-300 border border-blue-200 dark:border-blue-800 rounded-lg hover:bg-blue-100 dark:hover:bg-blue-900/40 transition-colors"
                >
                    شرکت در آزمون
                </button>
            </div>

        </>
    );
}

export default ExamStartSection;